import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContratoService } from '../../../base/services/contrato.service';
import { Contrato } from 'src/app/base/domain/contrato.model';
import { DialogService } from '../../services/dialog.service';
import { ReturnAPI } from 'src/app/base/domain/return-api.model';
import { OrdemParcelaDTO } from 'src/app/base/domain/dto/ordem-parcela';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Moment } from 'moment';
import { Produto } from 'src/app/base/domain/produto.model';

interface Situacao {
  label: string;
  value: number;
}

@Component({
  selector: 'app-ordem-parcela',
  templateUrl: './ordem-parcela.component.html',
  styleUrls: ['./ordem-parcela.component.css'],
})
export class OrdemParcelaComponent implements OnInit {
  contratoId: number;
  contrato!: Contrato;
  ordemParcelas: OrdemParcelaDTO[] = [];
  parcelaSelecionada: OrdemParcelaDTO | null = null;
  produto!: Produto;
  produtoId: number | null = null;

  situacoes: Situacao[] = [
    { label: 'GERADA', value: 0 },
    { label: 'COBRADA', value: 1 },
    { label: 'LIQUIDADA', value: 2 },
    { label: 'CANCELADA', value: 3 },
    { label: 'PRAZO_ENCERRADO', value: 4 },
    { label: 'QUITADA', value: 5 },
    { label: 'CONFIRMADA', value: 6 },
    { label: 'AGENDADA', value: 7 },
    { label: 'LIQUIDADA_ADMINISTRACAO', value: 8 },
    { label: 'PENDENTE_CONFIRMAR_REPASSE_CLIENTE', value: 9 },
    { label: 'REPACTUADA', value: 10 },
  ];

  constructor(
    private dialogRef: MatDialogRef<OrdemParcelaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { contratoId: number },
    private contratoService: ContratoService,
    private dialogService: DialogService
  ) {
    this.contratoId = data.contratoId;
  }

  ngOnInit(): void {
    this.carregarProduto();
    this.loadContrato();
  }

  private carregarProduto(): void {
    const stored = sessionStorage.getItem('produto');
    if (stored) {
      try {
        this.produto = JSON.parse(stored);
        this.produtoId = Number(this.produto.id);
      } catch {
        this.produtoId = null;
      }
    }
  }

  onPickerEvent(event: MatDatepickerInputEvent<Moment>, parcela: OrdemParcelaDTO): void {
    parcela.dataVencimento = event.value?.toDate() || null;
  }

  private loadContrato(): void {
    this.contratoService.findOne(this.contratoId).subscribe((res: ReturnAPI<Contrato>) => {
      if (res.success && res.object) {
        this.contrato = res.object;
        this.ordemParcelas = this.contrato.listParcela
          .sort((a, b) => a.ordem - b.ordem)
          .map(p => ({
            parcelaId: p.id,
            ordem: p.ordem,
            dataVencimento: p.dataVencimento ? new Date(p.dataVencimento) : null,
            situacaoParcela: Number(p.situacaoParcela),
          }));
      } else {
        const msg = res?.messages?.[0]?.text || 'Erro ao carregar contrato!';
        this.dialogService.feedbackError(msg);
      }
    });
  }

  salvar(): void {
    if (!this.parcelaSelecionada || !this.produtoId) return;

    const dto = {
      parcelaId: this.parcelaSelecionada.parcelaId,
      ordem: this.parcelaSelecionada.ordem,
      dataVencimento: this.parcelaSelecionada.dataVencimento,
      situacaoParcela: this.parcelaSelecionada.situacaoParcela,
    };

    this.contratoService.alterarOrdemParcela(dto).subscribe({
      next: (res) => {
        if (res.success) {
          this.dialogService.feedbackSuccess('Parcela atualizada com sucesso!');
          this.loadContrato();
          setTimeout(() => this.dialogRef.close(true), 2000);
        } else {
          this.dialogService.feedbackError(res.messages?.[0]?.text || 'Erro ao atualizar parcela!');
        }
      },
      error: (err) => {
        const msg = err?.error?.messages?.[0]?.text || 'Erro ao atualizar parcela!';
        this.dialogService.feedbackError(msg);
      }
    });
  }


  fechar(): void {
    this.dialogRef.close();
  }
}
